import { Typography } from '@mui/material';

type TransactionReviewAmountProps = {
  amount: string;
};

export default function TransactionReviewAmount({
  amount,
}: TransactionReviewAmountProps) {
  const color =
    amount[0] === '-'
      ? 'error.main'
      : amount[0] === '+'
        ? 'success.main'
        : 'grey';

  return <Typography sx={{ color }}>{amount}</Typography>;
}
